import React, { useState } from "react";
import Button from "@amzn/meridian/button";
import Column from "@amzn/meridian/column";
import Icon from "@amzn/meridian/icon";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import editTokens from "@amzn/meridian-tokens/base/icon/edit";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import Box from "@amzn/meridian/box";
import {
    IDisplayFeaturesOrSpacesProps,
    propertyClassTypes,
    propertyQualityTypes,
    propertySpaceSpaceType,
} from "./definitions";
import { formatStatus } from "../table/utils";
import _ from "lodash";
import { DeleteModal } from "./DeleteModal";
import { formatNumber } from "../../utils/formattingUtils";

export const DisplaySpacesOnForm: React.FC<
    Omit<IDisplayFeaturesOrSpacesProps, "featureDetails">
> = ({ spaceDetails, sheetName, handleEditUpdateSheetAndOpen, handleDeleteItem }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const getFormatedSpaceInfo = currentSpace => {
        const constructionClass = _.find(propertyClassTypes, {
            value: currentSpace.constructionClass,
        });
        const constructionQuality = _.find(propertyQualityTypes, {
            value: currentSpace.constructionQuality,
        });
        const spaceType = _.find(propertySpaceSpaceType, {
            value: currentSpace.spaceType,
        });

        return {
            constructionClass: "Construction class: " + constructionClass?.label,
            constructionQuality: " Construction quality: " + constructionQuality?.label,
            spaceTypeAndSize: `${spaceType?.label}: ${formatNumber(currentSpace.buildingSize)} sqft`,
            numStoriesAndHeight: `${formatNumber(currentSpace.noOfStories)} stories,  
            ${formatNumber(currentSpace.heightPerStory)} ft/story`,
        };
    };

    return (
        <Column width={"fill"} spacing={"400 none"}>
            {spaceDetails?.map(currentSpace => {
                const {
                    constructionClass,
                    constructionQuality,
                    spaceTypeAndSize,
                    numStoriesAndHeight,
                } = getFormatedSpaceInfo(currentSpace);

                return (
                    <Box type={"outline"} width={"fit"}>
                        <Row backgroundColor={"subdued"} width={"100%"} spacingInset={"400"}>
                            <Column width={"100%"}>
                                <Row>
                                    <Text type={"h200"}>{currentSpace.spaceName} </Text>
                                    {formatStatus(currentSpace.status)}
                                </Row>
                                <Row width={"100%"} widths={["50%", "50%"]} spacing={"600"}>
                                    <Column spacing={"none"}>
                                        <Text alignment={"start"}>{spaceTypeAndSize}</Text>
                                        <Text alignment={"start"}>{numStoriesAndHeight}</Text>
                                    </Column>
                                    <Column spacing={"none"}>
                                        <Text alignment={"start"}>{constructionClass}</Text>
                                        <Text alignment={"start"}>{constructionQuality}</Text>
                                    </Column>
                                </Row>
                            </Column>
                            <Row>
                                <Button
                                    type="icon"
                                    onClick={() => {
                                        handleEditUpdateSheetAndOpen(sheetName, currentSpace.id);
                                    }}
                                >
                                    <Icon tokens={editTokens} />
                                </Button>
                                <Button
                                    type="icon"
                                    onClick={() => {
                                        setModalContent({
                                            id: currentSpace.id,
                                        });
                                        setIsModalOpen(true);
                                    }}
                                >
                                    <Icon tokens={trashTokens} />
                                </Button>
                            </Row>
                            {modalContent && (
                                <DeleteModal
                                    modalTitle={"Delete space"}
                                    modalDescription={"Are you sure you want to delete this space?"}
                                    confirmHandler={() => handleDeleteItem(modalContent.id)}
                                    isModalOpen={isModalOpen}
                                    setIsModalOpen={setIsModalOpen}
                                />
                            )}
                        </Row>
                    </Box>
                );
            })}
        </Column>
    );
};
